// import App from '../views/twStore/App';
import Select from '../views/twStore/SelectV2';

import TestSelect from '../views/twStore/TestSelect';
import Pay from '../views/twStore/Pay';
import Result from '../views/twStore/Result';
import BrowserPaying from '../views/twStore/BrowserPaying';
import { pageType, viewPage } from '@plugins/biPoint/_configWebstoreV0';
export default [
  // 2024.11.12 兼容后台储值页链接生成格式
  {
    path: '/',
    name: 'home',
    meta: {
      pageName: pageType.homePage
    },
    component: Pay,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.homePage);
      next();
    }
  },
  {
    path: '/select',
    name: 'select',
    meta: {
      pageName: pageType.homePage
    },
    component: Select,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.homePage);
      next();
    }
  },
  {
    path: '/pay',
    name: 'pay',
    meta: {
      pageName: pageType.homePage
    },
    component: Pay,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.homePage);
      next();
    }
  },
  {
    path: '/web',
    name: 'web',
    meta: {
      pageName: pageType.homePage
    },
    component: Pay,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.homePage);
      next();
    }
  },
  {
    path: '/result',
    name: 'result',
    meta: {
      pageName: pageType.resultPage
    },
    component: Result,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.resultPage);
      next();
    }
  },
  {
    path: '/browserPay',
    name: 'browserPay',
    meta: {
      pageName: pageType.browserPay
    },
    component: BrowserPaying,
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.browserPay);
      next();
    }
  },
  {
    path: '/test',
    name: 'test',
    component: TestSelect
  }
];
